/**
 * Loading Spinner Component
 * Reusable loading spinner with different variants
 */

function LoadingSpinner({ 
  size = 'md', 
  variant = 'spinner',
  text = '',
  fullScreen = false 
}) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
  };

  const Spinner = () => (
    <div
      className={`${sizeClasses[size]} border-4 rounded-full animate-spin`}
      style={{
        borderTopColor: 'var(--buttons-background-color)',
        borderRightColor: 'var(--buttons-background-color)',
        borderBottomColor: 'rgba(190, 5, 250, 0.1)',
        borderLeftColor: 'rgba(190, 5, 250, 0.1)',
      }}
    />
  );

  const Dots = () => (
    <div className="flex items-center gap-1.5">
      <div
        className={`${sizeClasses[size]} rounded-full animate-bounce`}
        style={{
          backgroundColor: 'var(--buttons-background-color)',
          animationDelay: '0ms',
        }}
      />
      <div
        className={`${sizeClasses[size]} rounded-full animate-bounce`}
        style={{
          backgroundColor: 'var(--buttons-background-color)',
          animationDelay: '150ms',
        }}
      />
      <div
        className={`${sizeClasses[size]} rounded-full animate-bounce`}
        style={{
          backgroundColor: 'var(--buttons-background-color)',
          animationDelay: '300ms',
        }}
      />
    </div>
  );

  const Pulse = () => (
    <div
      className={`${sizeClasses[size]} rounded-full animate-pulse`}
      style={{
        backgroundColor: 'var(--buttons-background-color)',
      }}
    />
  );

  const renderLoader = () => {
    switch (variant) {
      case 'dots':
        return <Dots />;
      case 'pulse':
        return <Pulse />;
      case 'spinner':
      default:
        return <Spinner />;
    }
  };

  const content = (
    <div className="flex flex-col items-center justify-center gap-3">
      {renderLoader()}
      {text && (
        <p className="text-sm text-gray-600 font-medium">{text}</p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm z-50">
        {content}
      </div>
    );
  }

  return content;
}

export default LoadingSpinner;

